import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const purchaseType = searchParams.get('type') || 'digital';

  useEffect(() => {
    toast.success('Betaling suksesvol ontvang!');
  }, []);

  const isPhysical = purchaseType === 'physical' || purchaseType === 'both';
  const isDigital = purchaseType === 'digital' || purchaseType === 'both';

  return (
    <div className="min-h-screen py-24 md:py-32 px-6 md:px-12 flex items-center justify-center">
      <div className="max-w-2xl text-center">
        <div className="mb-8">
          <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-green-100 flex items-center justify-center">
            <svg className="w-12 h-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-normal tracking-tight text-charcoal mb-6">
            Betaling Ontvang
          </h1>
          
          {isPhysical && (
            <div className="bg-gold/10 border border-gold/30 rounded-sm p-6 mb-8">
              <h2 className="font-heading text-2xl text-charcoal mb-3">Fisiese Boek Bestelling</h2>
              <p className="font-body text-lg leading-relaxed text-muted-charcoal">
                U betaling is ontvang. Die boek sal binne 3-5 werksdae na u adres gekoerier word. 
                U sal 'n e-pos ontvang met die spoor-nommer sodra dit versend is.
              </p>
            </div>
          )}

          {isDigital && (
            <div className="bg-parchment border border-charcoal/10 rounded-sm p-6 mb-8">
              <h2 className="font-heading text-2xl text-charcoal mb-3">Digitale Toegang</h2>
              <p className="font-body text-lg leading-relaxed text-muted-charcoal">
                U het nou volledige toegang tot die digitale weergawe van{' '}
                <em>Die Afrikaner se Goue Kalf</em>. U kan die boek onmiddellik begin lees.
              </p>
            </div>
          )}

          <p className="font-body text-lg leading-relaxed text-muted-charcoal mb-8">
            Baie dankie vir u ondersteuning! 'n Bevestigingse-pos is na u gestuur.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {isDigital && (
            <Link
              to="/reader"
              data-testid="cta-read-now"
              className="bg-charcoal text-parchment hover:bg-charcoal/80 rounded-sm px-8 py-4 font-ui uppercase tracking-widest text-sm transition-colors duration-300"
            >
              Lees die Boek Nou
            </Link>
          )}
          <Link
            to="/dashboard"
            data-testid="cta-dashboard"
            className="border border-charcoal text-charcoal hover:bg-charcoal hover:text-parchment rounded-sm px-8 py-4 font-ui uppercase tracking-widest text-sm transition-colors duration-300"
          >
            Gaan na Biblioteek
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
